import { Routes, Route } from "react-router-dom";
import { LoginPage } from "./pages/Login";
import { HomePage } from "./pages/Home";
import Carnet from "./pages/Carnet";
import ProtectedRoute from "./ProtectedRoute";
import "./App.scss";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/carnet"
        element={
          <ProtectedRoute>
            <Carnet />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
